import { render, staticRenderFns } from "./commListJccg.vue?vue&type=template&id=bfef21e2&scoped=true"
import script from "./commListJccg.vue?vue&type=script&lang=js"
export * from "./commListJccg.vue?vue&type=script&lang=js"
import style0 from "./commListJccg.vue?vue&type=style&index=0&id=bfef21e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfef21e2",
  null
  
)

export default component.exports